import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import swal from 'sweetalert2';
import useToast from './useToast';
import useShareModal from './useShareModal';

const openGql = gql`
  mutation open($assemblyId: String!, $condominiumId: String!) {
    openAssembly(assemblyId: $assemblyId, condominiumId: $condominiumId) {
      _id
      status
    }
  }
`;

const closeGql = gql`
  mutation close($assemblyId: String!, $condominiumId: String!) {
    closeAssembly(assemblyId: $assemblyId, condominiumId: $condominiumId) {
      _id
      status
    }
  }
`;

export default function useAssemblyActions({ assembly, onCompleted }) {
  const variables = {
    assemblyId: assembly && assembly._id,
    condominiumId: assembly && assembly.condominium,
  };
  const shareModal = useShareModal();
  const toast = useToast();

  const [open, { loading: opening }] = useMutation(openGql, {
    variables,
    onCompleted: async args => {
      await shareModal();
      onCompleted(args);
    },
  });
  const [closeFn, { loading: closing }] = useMutation(closeGql, {
    variables,
    onCompleted: args => {
      toast.fire({
        icon: 'success',
        text: `${assembly.type === 'meeting' ? 'Reunião' : 'Assembleia'} encerrada com sucesso.`,
      });
      onCompleted(args);
    },
  });

  const close = async args => {
    const { value } = await swal.fire({
      customClass: {
        confirmButton: 'bg-primary',
      },
      text: `Deseja encerrar a ${assembly.type === 'meeting' ? 'reunião' : 'assembleia'}?`,
      showCancelButton: true,
    });

    if (value) return closeFn(args);
    return Promise.resolve();
  };

  return { open, close, opening, closing };
}
